import { StringFormatter } from '@repo/toolkit/string'

import { Paths } from '../../../../lib/constants/path'
import { olTypeEnumMapping } from '../../../../lib/types/enums/ol/ol-type.enum'
import { Ol } from '../../../../lib/types/models/ol/ol'

export const constructOlCenterPath = (path: string, olId: number) =>
  Paths.OL_CENTER_DETAILS_PAGE.replace(':id', olId.toString()).replace('*', '') + path

export const getOlName = (
  ol?: Pick<Ol, 'mainContactFirstName' | 'mainContactLastName'>,
  options?: { lastNameFirst?: boolean; allUpperCase?: boolean; type?: Ol['type'] }
) => {
  if (!ol) return '-'
  const { mainContactFirstName, mainContactLastName } = ol

  const uppercasedLastName = mainContactLastName.toUpperCase()
  const formattedContactFirstName = mainContactFirstName
    ? options?.allUpperCase
      ? mainContactFirstName.toUpperCase()
      : StringFormatter.capitalize(mainContactFirstName)
    : undefined
  const olTypeLabel = options?.type ? `(${olTypeEnumMapping[options.type].label})` : undefined

  return options?.lastNameFirst
    ? [uppercasedLastName, formattedContactFirstName, olTypeLabel].filter(Boolean).join(' ')
    : [formattedContactFirstName, uppercasedLastName, olTypeLabel].filter(Boolean).join(' ')
}
